module.exports = __webpack_public_path__ + "static/account-f763f97bb17eeab1a9f600cb303f739f.svg";